const urlSearchParams = new URLSearchParams(window.location.search)

function getParam(key: string, defaultValue: string = "") {
  return getWindowData(key) || urlSearchParams.get(key) || defaultValue
}

function getWindowData(key: string): string | undefined {
  return process.env.NODE_ENV === "production"
    ? (window as any)[`WOWNET_${key.toLocaleUpperCase()}`]
    : undefined
}

export { getParam }
